export default {
  actions: {
    createLocation({ dispatch }, location) {
      // Accepts address or id in location
      return Vue.$http
        .post(`client/opportunities/${location.opportunity.id}/locations`, {
          location,
        })
        .then(
          ({ data }) => dispatch('fetch', location.opportunity.id),
          ({ data }) => data.errors || data.error
        )
    },

    updateLocation({ dispatch }, location) {
      return Vue.$http
        .patch(`client/opportunities/${location.opportunity.id}/locations/${location.id}`, location)
        .then(() => dispatch('fetch', location.opportunity.id))
    },

    removeLocation({ dispatch }, location) {
      return Vue.$http
        .delete(`client/opportunities/${location.opportunity.id}/locations/${location.id}`)
        .then(() => dispatch('fetch', location.opportunity.id))
    },
  },
}
